import { Company } from '../company/company.model';

export class Attendee {
  id: string = '';
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  phone1: string = '';
  companyId: string = '';
  company: Company;
  asLeader: boolean = false;
  createdAt: Date = new Date();
  updatedAt: Date = new Date();

  static fromObject(data): Attendee {
    if (typeof data === 'string') {
      data = JSON.parse(data);
    }
    let dates = {
      createdAt: new Date(data.createdAt),
      updatedAt: new Date(data.updatedAt),
    };
    return Object.assign(new Attendee(), data, dates);
  }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/attendee/attendee.model.ts
 **/